import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { MeetingTemplateForm } from './use-meeting-template-form';

export const useMeetingTemplateFormContext = ():
  | UseFormReturn<MeetingTemplateForm>
  | never => {
  const form = useFormContext<MeetingTemplateForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useMeetingTemplateFormContext can only be used inside a Meeting Template Forms Context Provider.',
    );

  return form;
};
